export default __webpack_public_path__ + "static/media/increase.4d7236a7.png";